export default __webpack_public_path__ + "static/media/une (6).745ee9c7.jpg";